/*
export const someGetter = (state) => {}
 */
import _ from 'lodash'
import { date } from 'quasar'
export default {
  userList,
  userTypes,
  autoCompleteOptions,
  managerAutoCompleteOptions,
  affiliateAutoCompleteOptions,
  affiliateOptions,
  recruiterOptions,
  managerOptions,
  administratorOptions,
  managerOptionIds,
  affiliateIds,
  managerCourseIds,
  affiliateCourseIds
}

function userList (state, getters, rootState) {
  return state.list.map(user => {
    const userTypes = _.map(state.roles, item => item.field)
    _.each(user, (val, key) => {
      if (_.includes(userTypes, key)) {
        if (user[key]) user[key].ACTIVE_IND = (user[key].ACTIVE_IND === 1)
      }
    })
    if (user.ADDRESSES) {
      _.each(user.ADDRESSES[0], (addressValue, addressKey) => {
        user[addressKey] = addressValue
        if (addressKey === 'user_address') {
          user.USER_ADDRESS_ID = user[addressKey].USER_ADDRESS_ID
          user.LK_ADDRESS_TYPE_ID = user[addressKey].LK_ADDRESS_TYPE_ID
        }
      })
      _.each(user.STATE, (stateValue, stateKey) => {
        user[stateKey] = stateValue
      })
    }
    if (user.USER_TYPES) {
      user.USER_ROLES = _.map(user.USER_TYPES, (userType) => {
        return userType.USER_TYPE.USER_TYPE_NAME 
      })
    }
    // user.USER_DOB = date.formatDate(user.USER_DOB, rootState.shared.formats.date)
    user.ACTIVE_IND = !!user.ACTIVE_IND
    user.ACTIVE_STATUS = (user.ACTIVE_IND) ? 'Active' : 'Inactive'

    return user
  })
}

function autoCompleteOptions (state, getters, rootState) {
  return state.autoCompleteList.map(user => { 
    const fullName = user.USER_LAST_NAME + ', ' + user.USER_FIRST_NAME
    return { label: fullName, value: fullName, item: user }
  })
}

function managerAutoCompleteOptions (state, getters, rootState) {
  return state.managerAutoCompleteList.map(manager => { 
    if (manager.MANAGER_NAME) {
      const label = manager.MANAGER_CODE + ' - ' + manager.MANAGER_NAME
      return { label: label, value: label, item: manager }
    } else {
      const fullName = manager.USER_LAST_NAME + ', ' + manager.USER_FIRST_NAME
      return { label: fullName, value: fullName, item: manager }
    }
  })
}

function affiliateAutoCompleteOptions (state, getters, rootState) {
  return state.affiliateAutoCompleteList.map(affiliate => { 
    if (affiliate.AFFILIATE_NAME) {
      const label = affiliate.AFFILIATE_CODE + ' - ' + affiliate.AFFILIATE_NAME
      return { label: label, value: label, item: affiliate }
    } else {
      const fullName = affiliate.USER_LAST_NAME + ', ' + affiliate.USER_FIRST_NAME
      return { label: fullName, value: fullName, item: affiliate }
    }
  })
}

function userTypes (state, getters, rootState) {
  const userTypes = _.map(rootState.shared.userTypes, userType => userType.USER_TYPE_NAME)
  return _.filter(state.selectedUser, (val, key) => {
    // console.log('includes', _.includes(userTypes, key))
    return _.includes(userTypes, key) 
  }).map(item => { 
    if (item) {
      item.ACTIVE_IND = !!item.ACTIVE_IND
    }
    return item
  })
}

function affiliateOptions (state) {
  const affiliateOptions = _.map(state.affiliateList, affiliate => {
    return { 
      label: affiliate.AFFILIATE_CODE + ' - ' + affiliate.AFFILIATE_NAME,
      value: affiliate.AFFILIATE_ID
    }
  })
  if(state.userWizardModal.open){
    if(state.affiliateForm.ACTIVE_IND){
      let code = state.affiliateForm.AFFILIATE_CODE
      affiliateOptions.unshift({
        label: (code ? code + ' - ' : '') + state.affiliateForm.AFFILIATE_NAME,
        value: 'new'
      })
    }
  }
  return affiliateOptions
}

function recruiterOptions (state) {
  const recruiterOptions = _.map(state.recruiterList, recruiter => {
    return { 
      label: recruiter.USER.USER_FIRST_NAME + ' ' + recruiter.USER.USER_LAST_NAME,
      value: recruiter.RECRUITER_ID
    }
  })
  return recruiterOptions
}

function managerOptions (state) {
  const managerOptions = _.map(state.managerList, manager => {
    return { 
      label: manager.USER.USER_FIRST_NAME + ' ' + manager.USER.USER_LAST_NAME,
      value: manager.MANAGER_ID
    }
  })
  return managerOptions
}

function administratorOptions (state) {
  const administratorOptions = _.map(state.administratorList, administrator => {
    return { 
      label: administrator.ADMINISTRATOR_NAME,
      value: administrator.ADMINISTRATOR_ID
    }
  })
  return administratorOptions
}

function managerOptionIds (state, getters) {
  return getters.managerOptions.map(m => m.value)
}

function affiliateIds (state) {
  let affiliates = state.instructorForm.INSTRUCTOR_AFFILIATES
  affiliates = affiliates && affiliates.length ? _.map(affiliates, affiliate => affiliate.AFFILIATE_ID) : []
  return affiliates
}

function managerCourseIds (state) {
  let courses = state.managerForm.COURSES
  courses = courses && courses.length ? _.map(courses, course => course.COURSE_ID) : []
  return courses
}

function affiliateCourseIds (state) {
  let courses = state.affiliateForm.COURSES
  courses = courses && courses.length ? _.map(courses, course => course.COURSE_ID) : []
  return courses
}
